import { Link } from 'react-router-dom'
import { useMemo } from 'react'
import { Linkedin, Instagram, Twitter } from 'lucide-react'
import { motion } from 'framer-motion'

const footerLinks = [
  {
    title: "Company",
    links: [
      { label: "About Us", href: "/about" },
      { label: "Careers", href: "/careers" },
      { label: "Contact", href: "/contact" },
    ],
  },
  {
    title: "Solutions",
    links: [
      { label: "Investment", href: "/investment" },
      { label: "Software", href: "/software" },
      { label: "Consulting", href: "/consulting" },
      { label: "Research", href: "/research" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", href: "/privacy" },
      { label: "Terms of Service", href: "/terms" },
      { label: "Cookie Policy", href: "/cookies" },
    ],
  },
]

export function Footer() {
  const memoizedFooterLinks = useMemo(() => footerLinks, [])
  
  return (
    <footer className="border-t">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {memoizedFooterLinks.map((section) => (
            <div key={section.title}>
              <h3 className="font-semibold mb-3">{section.title}</h3>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-neutral-600 hover:text-neutral-900 dark:text-neutral-400 dark:hover:text-neutral-50"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <div>
            <h3 className="font-semibold mb-3">Connect</h3>
            <p className="text-sm text-neutral-600 dark:text-neutral-400 mb-4">
              Stay updated with our newsletter
            </p>
            <div className="flex items-center space-x-3 mb-4">
              <motion.a
                href="https://www.linkedin.com/company/pshg/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full hover:bg-neutral-100 dark:hover:bg-neutral-800 relative group"
                aria-label="LinkedIn"
                whileHover={{ scale: 1.1 }}
                transition={{ type: "spring", stiffness: 400, damping: 10 }}
              >
                <Linkedin className="h-5 w-5 text-neutral-600 dark:text-neutral-400" />
                <span className="absolute -top-10 left-1/2 -translate-x-1/2 bg-black text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
                  LinkedIn
                </span>
              </motion.a>
              <motion.a
                href="https://www.instagram.com/pshg.co/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full hover:bg-neutral-100 dark:hover:bg-neutral-800 relative group"
                aria-label="Instagram"
                whileHover={{ scale: 1.1 }}
                transition={{ type: "spring", stiffness: 400, damping: 10 }}
              >
                <Instagram className="h-5 w-5 text-neutral-600 dark:text-neutral-400" />
                <span className="absolute -top-10 left-1/2 -translate-x-1/2 bg-black text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
                  Instagram
                </span>
              </motion.a>
              <motion.a
                href="https://x.com/pshg_co"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full hover:bg-neutral-100 dark:hover:bg-neutral-800 relative group"
                aria-label="Twitter"
                whileHover={{ scale: 1.1 }}
                transition={{ type: "spring", stiffness: 400, damping: 10 }}
              >
                <Twitter className="h-5 w-5 text-neutral-600 dark:text-neutral-400" />
                <span className="absolute -top-10 left-1/2 -translate-x-1/2 bg-black text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
                  Twitter
                </span>
              </motion.a>
            </div>
            <Link
              to="/"
            >
              <img
                src="/pshg_initials_transparent.png"
                alt="PSHG Logo"
                className="h-12"
              />
            </Link>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t text-center text-sm text-neutral-600 dark:text-neutral-400">
          © {new Date().getFullYear()} Polymath Solutions. All rights reserved.
        </div>
      </div>
    </footer>
  )
} 